<template>
  <div class="text-center Fp-4">
    <vue-dropzone
      class="custom-dropzone"
      id="dropzone"
      ref="myVueDropzone"
      :max-file-size-in-mb="maxFileSizeInMB"
      :max-files="maxFiles"
      :use-custom-slot="true"
      @vdropzone-file-added="handleUploadSuccess"
      :options="dropzoneOptions"
    >
      <div class="dropzone-custom-content text-center">
        <img src="@/assets/icons/upload-p.svg" alt="Importer" class="upload-icon mb-3" :style="{ height: this.iconSize + 'px' }" />
        <h5 class="font-weight-bold mb-2 text-uppercase">{{ uploadMessage }}</h5>
        <p class="text-muted mb-0">{{ formatMessage }}</p>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'BannerDropzone',
  components: {
    vueDropzone,
  },
  props: {
    maxFiles: {
      type: Number,
      default: 1,
    },
    maxFileSizeInMB: {
      type: Number,
      default: 5,
    },
    acceptedFiles: {
      type: String,
      default: 'image/*',
    },
    uploadMessage: {
      type: String,
      default: 'Importez votre photo',
    },
    iconSize: {
      type: Number,
      default: 108,
    },
    formatMessage: {
      type: String,
      default: 'Format accepté : JPG, PNG et Taille maximale : 5 Mo.',
    },
  },
  data() {
    return {
      bannerImage: null,
      dropzoneOptions: {
        url:'/test',
        autoProcessQueue: false,
        maxFiles: this.maxFiles,
        acceptedFiles: this.acceptedFiles,
        addRemoveLinks: false,
        dictDefaultMessage: '',
        thumbnailWidth: 150,
        thumbnailHeight: null,
      },
    }
  },
  watch: {
    maxFiles(newVal) {
      this.dropzoneOptions.maxFiles = newVal;
    },
    acceptedFiles(newVal) {
      this.dropzoneOptions.acceptedFiles = newVal;
    }
  },
  methods: {

    handleUploadSuccess(file) {
      this.bannerImage = file;
      this.$emit('upload-success',file)

    },

    clearFiles() {
      this.$refs.myVueDropzone.removeAllFiles()
      this.bannerImage = null
    }
  }
}
</script>

<style scoped>
.custom-dropzone {
  border: 2px dashed #756f60;
  border-radius: 12px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border 0.3s ease, background-color 0.3s ease;
}
.custom-dropzone:hover {
  border-color: #756f60;
  background-color: #f0f8ff;
}
.upload-icon {
  opacity: 0.7;
  transition: transform 0.2s ease;
}
.upload-icon:hover {
  transform: scale(1.1);
  opacity: 1;
}
.dropzone-custom-content {
  padding: 20px;
}
.dropzone-custom-content h5 {
  font-size: 1.2rem;
  color: #333;
}
.dropzone-custom-content p {
  font-size: 0.9rem;
  color: #666;
}
</style>
